<template>
	<div>
		<b-card class="shadow">
			<highcharts :options="chartOptions" style="margin-top: 50px"></highcharts>
		</b-card>
	</div>
</template>

<script>
import { Chart } from 'highcharts-vue'

export default {
	name: "GroupDashboard",
	data() {
		return {

		}
	},
	components: {
		highcharts: Chart
	},
	props: ['groupList'],
	computed: {
		groupValue() {
			let list = []
			if (list.length === 0) {
				for (const listKey in this.groupList) {
					let obj = []
					obj.push(this.groupList[listKey].value)
					list.push(obj)
					obj = []
				}
				return list
			}
		},
		groupName1() {
			let list = []
			if (list.length === 0) {
				for (const listKey in this.groupList) {
					let obj = {}
					obj.name = this.groupList[listKey].groupName
					obj.y = this.groupList[listKey].value
					obj.drilldown = this.groupList[listKey].groupName
					list.push(obj)
					obj = {}
				}
				return list
			}
		},
		chartOptions() {
			return {
				chart: {
					type: 'column'
				},
				title: {
					align: 'center',
					text: 'ТОП ТОВАРЫ'
				},
				// subtitle: {
				// 	align: 'center',
				// 	text: 'Click the columns to view versions. Source: <a href="http://statcounter.com" target="_blank">statcounter.com</a>'
				// },
				accessibility: {
					announceNewData: {
						enabled: true
					}
				},
				xAxis: {
					type: 'category'
				},
				yAxis: {
					title: {
						text: 'ТОП ТОВАРЫ'
					}

				},
				legend: {
					enabled: false
				},
				plotOptions: {
					series: {
						borderWidth: 0,
						dataLabels: {
							enabled: true,
							format: '<b style="color:{point.color}">{point.y}.00</b>'
						}
					}
				},

				tooltip: {
					headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
					pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>'
				},

				series: [
					{
						name: 'DUTY FREE',
						colors: ['#9b20d9', '#9215ac', '#861ec9', '#7a17e6', '#7010f9', '#691af3', '#6225ed', '#5b30e7', '#533be1', '#4c46db', '#4551d5', '#3e5ccf', '#3667c9', '#2f72c3', '#277dbd', '#1f88b7', '#1693b1', '#0a9eaa', '#03c69b', '#00f194'],
						colorByPoint: true,
						data: this.groupName1,
					}
				],
			}
		}
	},
	created() {

	}
}
</script>
<style scoped>
.stock {
	width: 70%;
	margin: 0 auto
}
</style>
